import script from "./Desktop.vue?vue&type=script&lang=ts&setup=true"
export * from "./Desktop.vue?vue&type=script&lang=ts&setup=true"

import "./Desktop.vue?vue&type=style&index=0&id=75406852&lang=less&scope=true"

const __exports__ = script;

export default __exports__